import { Controller } from 'stimulus';

class LoginAdsController extends Controller {
  connect() {
    EventManager.on('login-ads-loaded', () => {
      this.element.classList.add(['t-py-5','t-pr-5'])
    })
  }
}

export default LoginAdsController;
